import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import { parseISO, format } from 'date-fns';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Calendar, DateObject } from 'react-multi-date-picker';
import PerfectScrollbar from 'react-perfect-scrollbar';
import humanFileSize from 'utils/humanFileSize';
import { MapaMidiaItem, ClienteItem } from '../@types';
import { Anexo } from './styles';
import { FiDownload } from 'react-icons/fi';
import Button from 'components/Button';
import { downloadFile } from 'utils';
// import { Container } from './styles';

interface ViewMapaMidiaProps {
  mapaMidia: MapaMidiaItem;
  cliente: ClienteItem;
  isBloco: boolean;
}

const FormView: React.FC<ViewMapaMidiaProps> = ({
  mapaMidia,
  cliente,
  isBloco,
}: ViewMapaMidiaProps) => {
  const [dates, setDates] = useState<Date[]>([]);
  const [datesManha, setDatesManha] = useState<Date[]>([]);
  const [datesNoite, setDatesNoite] = useState<Date[]>([]);
  const [loadingDownload, setLoadingDownload] = useState(false);

  /**
   * USE REF
   */
  const mapaFormViewRef = useRef<FormHandles>(null);

  /**
   * USE CALLBACK
   */
  const handleDownloadMapa = useCallback(async (mapa: MapaMidiaItem) => {
    setLoadingDownload(true);
    try {
      if (mapa.download_url && mapa.originalfilename) {
        await downloadFile({
          url: mapa.download_url,
          name: mapa.originalfilename,
          fromAPI: true,
        });
      } else {
        throw new Error();
      }
    } catch (error) {
      toast.error(
        'Ocorreu um erro ao tentar baixar a planilha, tente novamente mais tarde',
      );
    } finally {
      setLoadingDownload(false);
    }
  }, []);

  const getCurrentDate = useCallback(() => {
    if (!!dates && dates.length > 0) {
      const date = new Date(dates[0]);
      return new DateObject({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      });
    }
  }, [dates]);

  /**
   * USE STATE
   */
  useMemo(() => {
    if (mapaMidia.datas) {
      if (!isBloco) {
        setDates(mapaMidia.datas?.map(mpdatas => mpdatas.data as Date));
      } else {
        setDatesManha(
          mapaMidia.datas
            ?.filter(d => d.turno === 'manha')
            .map(mpdatas => mpdatas.data as Date),
        );
        setDatesNoite(
          mapaMidia.datas
            ?.filter(d => d.turno === 'noite')
            .map(mpdatas => mpdatas.data as Date),
        );
      }
    }
  }, [isBloco, mapaMidia.datas]);

  return (
    <Form ref={mapaFormViewRef} onSubmit={() => {}}>
      <PerfectScrollbar>
        <section>
          <label> INFORMAÇÕES DO MAPA DE MIDIA</label>
          <div className="row">
            <label>Partido/Coligação</label>
            <p>{cliente.mnemonico}</p>
          </div>
          <div className="row">
            <label>Cargo</label>
            <p>{mapaMidia.cargo}</p>
          </div>
          <div className="row">
            <label>Data/hora recebimento</label>
            <p>
              {mapaMidia.recebido_at &&
                format(parseISO(mapaMidia.recebido_at), 'dd/MM/yyyy HH:mm')}
            </p>
          </div>
          {isBloco && (
            <>
              <div className="row">
                <label>CM - Título</label>
                <p>{`BL${
                  mapaMidia.cmbloco
                    ? mapaMidia.cmbloco.toString().padStart(3, '0')
                    : ''
                } - ${mapaMidia.titulo}`}</p>
              </div>
              <div className="row">
                <label>Observação</label>
                <p>{mapaMidia.observacao}</p>
              </div>
            </>
          )}
        </section>
        <section>
          <label>MAPA DE MIDIA</label>

          <Anexo>
            <div className="attach-thumb">
              <span> PDF </span>
            </div>
            <div className="attach-info">
              <p>{mapaMidia.originalfilename}</p>
              {!!mapaMidia.filesize && (
                <span>
                  Tamanho do arquivo:{' '}
                  {humanFileSize(Number(mapaMidia.filesize))}
                </span>
              )}
              <span>
                Enviado em:{' '}
                {mapaMidia.uploaded_at &&
                  format(
                    parseISO(mapaMidia.uploaded_at),
                    'dd/MM/yyyy HH:mm:ss',
                  )}
              </span>
            </div>
            <Button
              id="download"
              fill
              color="font"
              round
              onClick={() => handleDownloadMapa(mapaMidia)}
              disabled={loadingDownload}
            >
              <FiDownload />
            </Button>
          </Anexo>
        </section>
        <section>
          <label> DATA DE EXIBIÇÃO</label>
          {isBloco ? (
            <div className="calendario">
              <div>
                <label>MANHA</label>
                <Calendar
                  numberOfMonths={1}
                  multiple
                  value={datesManha}
                  shadow={false}
                  readOnly
                  currentDate={getCurrentDate()}
                  hideWeekDays={false}
                  className="bg-dark"
                  mapDays={({ date }) => {
                    const props: any = { className: '' };
                    const isWeekend = [0, 6].includes(date.weekDay.index);

                    if (isWeekend) props.className = 'highlight highlight-red';

                    return props;
                  }}
                />
              </div>
              <div>
                <label>NOITE</label>
                <Calendar
                  numberOfMonths={1}
                  multiple
                  value={datesNoite}
                  shadow={false}
                  readOnly
                  currentDate={getCurrentDate()}
                  hideWeekDays={false}
                  className="bg-dark"
                  mapDays={({ date }) => {
                    const props: any = { className: '' };
                    const isWeekend = [0, 6].includes(date.weekDay.index);

                    if (isWeekend) props.className = 'highlight highlight-red';

                    return props;
                  }}
                />
              </div>
            </div>
          ) : (
            <Calendar
              numberOfMonths={2}
              multiple
              value={dates}
              shadow={false}
              readOnly
              currentDate={getCurrentDate()}
              hideWeekDays={false}
              className="bg-dark"
              mapDays={({ date }) => {
                const props: any = { className: '' };
                const isWeekend = [0, 6].includes(date.weekDay.index);

                if (isWeekend) props.className = 'highlight highlight-red';

                return props;
              }}
            />
          )}
        </section>
      </PerfectScrollbar>
    </Form>
  );
};

export default FormView;
